module.exports = __webpack_public_path__ + "media/images/icons/flags/AZ-43679c95b856a3e09b5682dca0aacd59.svg";